'use client';

import * as React from 'react';
import warning from '../_util/warning';
import { changeConfirmLocale } from '../modal/locale';
import LocaleContext from './context';
export { default as useLocale } from './useLocale';
export var ANT_MARK = 'internalMark';

var LocaleProvider = function LocaleProvider(props) {
  var _props$locale = props.locale,
      locale = _props$locale === void 0 ? {} : _props$locale,
      children = props.children,
      _ANT_MARK__ = props._ANT_MARK__;

  if (process.env.NODE_ENV !== 'production') {
    process.env.NODE_ENV !== "production" ? warning(_ANT_MARK__ === ANT_MARK, 'LocaleProvider', '`LocaleProvider` is deprecated. Please use `locale` with `ConfigProvider` instead: http://u.ant.design/locale') : void 0;
  }

  React.useEffect(function () {
    var clearLocale = changeConfirmLocale(locale && locale.Modal);
    return clearLocale;
  }, [locale]);
  var getMemoizedContextValue = React.useMemo(function () {
    return Object.assign(Object.assign({}, locale), {
      exist: true
    });
  }, [locale]);
  return /*#__PURE__*/React.createElement(LocaleContext.Provider, {
    value: getMemoizedContextValue
  }, children);
};

if (process.env.NODE_ENV !== 'production') {
  LocaleProvider.displayName = 'LocaleProvider';
}

export default LocaleProvider;